import React, { useState, useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import ApiService from '../../services/apiService';
import Select from 'react-select';
import ApprovalUserGrid from './grid';
import { toast } from 'react-toastify';
import "./approval.css"
import { RiRefreshLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa6";
import { FaSave } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { getCompany, getUserName } from '../../../Redux/selecters';
import { ClipLoader } from 'react-spinners';
import { Modal } from 'react-bootstrap';
const ApprovalUser = () => {
    let navigate = useNavigate();
    const [Department, setDepartment] = useState([]);
    const [Active, setActive] = useState(true);
    const [DelegateActive, setDelegateActive] = useState(false);
    const [AutoAprove, setAutoAprove] = useState(false);
    const [Users, serUsers] = useState([]);
    const [SupplierTab, setSupplierTab] = useState(false);
    const [POTab, setPOTab] = useState(true);
    const apiService = new ApiService()
    const userName = useSelector(getUserName);
    const [rowData, setRowData] = useState([]);
    const [approvalList, setApprovalList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [signatureFile, setSignatureFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [previewModal, setPreviewModal] = useState(false);
    const companies = useSelector(getCompany);

    const [formData, setFormData] = useState({
        DocType: [],
        UserNo: [],
        UserRole: [],
        UserEmail: "",
        UserLevel: "",
        recordId: "",
        Signature: "",
        amountto: '',
        amountFrom: '0',
        delegateto: '',
        date: '',
        Department: [],
    })
    const DocType = [
        { value: 'Purchase Requisition', label: 'Purchase Requisition' },
        { value: 'Price Comparison', label: 'Price Comparison' },
        { value: 'Store Requisition', label: 'Store Requisition' },
        { value: 'POrder', label: 'Purchase Order' },
        { value: 'I Return', label: 'Issue Return' },
        { value: 'I Receive', label: 'Issue Receive' },
        { value: 'PR', label: 'Purchase Return' },
        { value: 'Quotation', label: 'Quotation' },
        { value: 'GRN', label: 'GRN' },
        { value: 'Invoice', label: 'Invoice' },
        { value: 'Issue', label: 'Item Issue' },
        { value: 'Stock Adjustment', label: 'Stock Take' },
        { value: 'ADJ', label: 'Stock Adjustment' },
    ]
    useEffect(() => {
        fetchData()
        fetchApprovalData();
    }, [])
    const handleActiveSelection = (e) => {
        setActive(e);
    }
    const handleDeleActiveSelection = (e) => {
        setDelegateActive(e);
    }
    const fetchData = async () => {
        const department = await apiService.get("GET_DEPARTMENT_MASTER");
        setDepartment(department?.data?.result);
        let DB = localStorage.getItem('DataBase')
        let selectCompany = companies?.companies.find((comp) => comp.dataDB === DB)
        let param = `?Usr_Company=${selectCompany?.companyNo}`
        const UsersLis = await apiService.getApiParamater("GET_USERS_LIST", param);
        serUsers(UsersLis?.data?.result);
    }
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    }
    const fetchApprovalData = async () => {
        try {
            const response = await apiService.get("GET_APPROVAL_USER");
            const approvals = response.data.result?.filter(dep => dep.active === 1)
            setRowData(approvals);
            setApprovalList(approvals)
        } catch (error) {
            console.error("Error fetching packing data:", error);
        }
    }
    const handleSignatureChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'application/pdf'];
        const maxSize = 10 * 1024 * 1024;

        if (!allowedTypes.includes(file.type)) {
            toast.warning('Please upload a signature image or PDF only.');
            e.target.value = '';
            return;
        }

        if (file.size > maxSize) {
            toast.warning('Signature file size must be 10 MB or less.');
            e.target.value = '';
            return;
        }

        if (previewImage?.url) {
            URL.revokeObjectURL(previewImage.url);
        }
        setPreviewImage(null);
        setPreviewModal(false);
        setSignatureFile(file);
        setFormData((prev) => ({ ...prev, Signature: file.name }));
    };

    const handleViewSignature = () => {
        if (!(signatureFile instanceof File)) {
            toast.warning('Please select a signature file first.');
            return;
        }

        const extension = signatureFile.name.split('.').pop()?.toLowerCase();
        const blobUrl = URL.createObjectURL(signatureFile);

        setPreviewImage({
            fileName: signatureFile.name,
            fileType: extension,
            url: blobUrl,
        });
        setPreviewModal(true);
    };

    const handleCloseSignaturePreview = () => {
        if (previewImage?.url) {
            URL.revokeObjectURL(previewImage.url);
        }
        setPreviewImage(null);
        setPreviewModal(false);
    };

    const handleRemoveSignature = () => {
        if (previewImage?.url) {
            URL.revokeObjectURL(previewImage.url);
        }
        setSignatureFile(null);
        setPreviewImage(null);
        setPreviewModal(false);
        setFormData((prev) => ({ ...prev, Signature: '' }));

        const fileInput = document.getElementById('signatureFile');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const uploadSignature = async (docNo) => {
        if (!(signatureFile instanceof File)) return null;

        const formDataUpload = new FormData();
        formDataUpload.append('Images', signatureFile, signatureFile.name);

        const response = await apiService.postMultiPart('UPLOAD_FILE', formDataUpload);

        if (!(response?.data?.statusCode === 201 && response?.data?.isSuccessful)) {
            throw new Error(response?.data?.message || 'Signature upload failed.');
        }

        const uploadedFileName = response?.data?.result?.split(',')?.[0]?.trim();
        if (!uploadedFileName) {
            throw new Error('Uploaded signature filename was not returned.');
        }

        const attachmentPayload = {
            docFilesDtos: [{
                srno: 1,
                docNo,
                docType: 'ApprovalUser',
                fileName: uploadedFileName,
                remarks: '',
            }],
        };

        const attachmentResponse = await apiService.post('CREATE_ATTACHMENT', attachmentPayload);
        if (!(attachmentResponse?.data?.isSuccessful || attachmentResponse?.data?.statusCode === 200 || attachmentResponse?.data?.statusCode === 201)) {
            throw new Error(attachmentResponse?.data?.message || 'Signature attachment could not be saved.');
        }

        return uploadedFileName;
    };

    const handleUser = async () => {
        try {
            setLoader(true);

            if (!formData?.UserNo?.label) {
                toast.warning("Select User to create Approval");
                setLoader(false);
                return;
            }
            if (!formData?.DocType?.value) {
                toast.warning("Select Document Type");
                setLoader(false);
                return;
            }
            if (!formData?.UserLevel) {
                toast.warning("Enter User level for Approval");
                setLoader(false);
                return;
            }
            // if (!(signatureFile instanceof File)) {
            //     toast.warning("Please upload a signature image or PDF.");
            //     setLoader(false);
            //     return;
            // }

            const currentDatetimeUTC = new Date().toISOString();
            const docNo = formData?.UserNo?.label;

            // Upload the signature first so the approval record stores the real server filename.
            const uploadedSignatureName = await uploadSignature(docNo);

            const body = {
                docType: formData?.DocType?.value,
                userNo: formData?.UserNo?.label,
                userLevel: formData?.UserLevel,
                department: formData?.Department?.label,
                active: Active === true ? 1 : 0,
                sigFilePath: uploadedSignatureName || "",
                isAutoApprove: AutoAprove === true ? 1 : 0,
                createdBy: userName,
                stockTypeName: "",
                fromPOAmount: formData?.amountFrom || 0,
                toPOAmount: formData?.amountto || 0,
                delegateTo: formData?.delegateto,
                delegateUntil: formData.date || currentDatetimeUTC.toString(),
                isDelegateUserActive: DelegateActive
            };

            const response = await apiService.post('CREATE_APPROVAL_USER', body);
            if (response?.data?.statusCode === 201) {
                setLoader(false);
                toast.success(response.data.message);
                navigate('/Inventory/ApprovalUser/List');
            } else {
                setLoader(false);
                toast.warning(response.data.message);
            }
        } catch (error) {
            setLoader(false);
            console.error('Error creating approval user:', error);
            toast.error(error?.message || "Something may be wrong try again later!");
        }
    }

    const handleDocTypeChange = (selectedOption) => {
        setFormData({ ...formData, DocType: selectedOption });
        const approvals = approvalList?.filter(dep => dep.docType === selectedOption?.value)
        setRowData(approvals)
    }
    const handleDepartmentChange = (selectedOption) => {
        setFormData({ ...formData, Department: selectedOption });
    }
    const handleUsersDrop = (selectedOption) => {
        setFormData({
            ...formData,
            UserNo: selectedOption,
            UserEmail: selectedOption?.value.emailId,
            UserRole: { label: selectedOption?.value?.role, value: selectedOption?.value?.role },
            Department: { label: selectedOption?.value?.department, value: selectedOption?.value?.department },
        });
    }
    const handleBackClick = () => {
        window.history.back();
    };
    const handleReset = () => {
        setSignatureFile(null);
        setPreviewImage(null);
        setPreviewModal(false);
        setFormData({
            DocType: [],
            UserNo: [],
            UserLevel: "",
            recordId: "",
            Signature: "",
            Department: [],
        });
    };
    return (
        <div className='px-4 pb-5'>
            <div className='d-flex justify-content-between pt-3'>
                <h5 className='col mainInvHead'>Approval User</h5>
                <div className='d-flex gap-3'>
                    {loader === true ?
                        <button className='mainbtn ' type="submit"><ClipLoader color="#ffffff" size={25} /></button> :
                        <button className='mainbtn ' type="submit" onClick={() => handleUser()}><FaSave className='center mt-1 mx-2' /><div>Save</div></button>
                    }
                    <button className='mainbtnRed' onClick={handleReset}><RiRefreshLine className='center mt-1 mx-2' /><div>Reset</div></button>
                    <button onClick={handleBackClick} className='mainbtn'><FaAngleLeft className='center mt-1 mx-2' /><div>Back</div></button>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Users Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row pb-3">
                            <div className="col-md-4 col-lg-4 justify-content-around d-flex">
                                <label htmlFor="validationCustom02" className="form-label  pt-2 start">User Name</label>
                                <Select
                                    value={formData.UserNo}
                                    onChange={handleUsersDrop}
                                    options={Users?.map((sup) => ({ value: sup, label: sup?.user_Name }))}
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                            <div className="col-md-4 col-lg-4 justify-content-around d-flex">
                                <label htmlFor="validationCustom02" className="form-label  pt-2 start">User Role</label>
                                <Select
                                    value={formData.UserRole} isDisabled
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                            <div className="col-md-4 col-lg-4 justify-content-around d-flex">
                                <label htmlFor="validationCustom02" className="form-label  pt-2 start">User Email</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="validationCustom02"
                                    name="UserEmail" disabled
                                    value={formData?.UserEmail}
                                    required
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-3">
                            <div className="col-md-4 d-flex justify-content-between ">
                                <label htmlFor="validationCustom02" className="form-label  pt-2 start">Signature</label>
                                <div className="w-100">
                                    <input
                                        type="file"
                                        className="form-Input w-100"
                                        id="signatureFile"
                                        name="signatureFile"
                                        accept="image/jpeg,image/png,image/jpg,image/webp,application/pdf"
                                        onChange={handleSignatureChange}
                                        required
                                    />
                                    {signatureFile?.name && (
                                        <div className="d-flex align-items-center gap-2 mt-2">
                                            <small className="text-muted">Selected: {signatureFile.name}</small>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-primary"
                                                onClick={handleViewSignature}
                                            >
                                                View
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-danger"
                                                onClick={handleRemoveSignature}
                                            >
                                                Remove
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-2 d-flex justify-content-end gap-3">
                                <div className='gap-3 center '>
                                    <input className="form-check-input"
                                        type="checkbox"
                                        id="Active" style={{ width: "20px", height: "20px" }}
                                        name="Active"
                                        checked={Active}
                                        onChange={(e) => handleActiveSelection(e.target.checked)}
                                    />
                                    <label className='px-2'>Active</label>
                                </div>
                                {/* <div className='gap-3 center '>
                                    <input className="form-check-input"
                                        type="checkbox"
                                        id="AutoAprove" style={{ width: "20px", height: "20px" }}
                                        name="AutoAprove"
                                        checked={AutoAprove}
                                        onChange={(e) => handleAutoApprove(e.target.checked)}
                                    />
                                    <label className='px-2'>Auto Aprove</label>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setPOTab(!POTab)}>
                    <div className='h6 pt-1'>Approval Details</div>
                </div>
                <div className={`slide-content ${POTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 ${POTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group row p-3  d-flex">
                            <div className="col-lg-4 d-flex justify-content-between">
                                <label htmlFor="validationCustom01" className="form-label  pt-2 start">Doc Type</label>
                                <Select
                                    value={formData?.DocType}
                                    options={DocType?.map((doc) => ({ value: doc?.value, label: doc?.label }))}
                                    onChange={handleDocTypeChange}
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                            <div className="col-lg-4 d-flex justify-content-between">
                                <label htmlFor="validationCustom02" className="form-label  pt-2 start">User Level</label>
                                <input
                                    type="text"
                                    className="form-Input w-100"
                                    id="validationCustom02"
                                    name="UserLevel"
                                    value={formData?.UserLevel}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="col-lg-4 d-flex justify-content-between">
                                <label htmlFor="validationCustom01" className="form-label  pt-2 start">Department</label>
                                <Select
                                    value={formData.Department}
                                    onChange={handleDepartmentChange}
                                    options={Department?.map((sup) => ({ value: sup, label: sup?.description }))}
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form-group row px-3 pb-3 d-flex justify-content-between">
                            <div className="col-4 d-flex justify-content-between ">
                                <label htmlFor="amountFrom" className="form-label  pt-2 start">Amount From</label>
                                <input
                                    type="number"
                                    className="form-Input w-100"
                                    id="amountFrom"
                                    name="amountFrom"
                                    value={formData?.amountFrom}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className="col-4 d-flex justify-content-between ">
                                <label htmlFor="amountto" className="form-label  pt-2 start">Amount To</label>
                                <input
                                    type="number"
                                    className="form-Input w-100"
                                    id="amountto"
                                    name="amountto"
                                    value={formData?.amountto}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className='col-4'></div>
                        </div>
                        <div className="bgbox1 p-3" >
                            <div className="form-group row justify-content-between" >
                                <div className="col-4 d-flex justify-content-between ">
                                    <label htmlFor="delegateto" className="form-label  pt-2 start">Delegate To</label>
                                    <Select
                                        isDisabled={DelegateActive === true ? false : true}
                                        value={formData.delegateto}
                                        onChange={handleUsersDrop}
                                        options={Users?.map((sup) => ({ value: sup, label: sup?.user_Name }))}
                                        className="w-100 p-0"
                                        theme={(theme) => ({
                                            ...theme,
                                            borderRadius: 5,
                                            padding: 9
                                        })}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                            option: (provided, state) => ({
                                                ...provided,
                                                backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                color: state.isFocused ? '#000 ' : '#000',
                                                ':hover': {
                                                    backgroundColor: '#F5F5F5',
                                                    color: '#000 ',
                                                },
                                            }),
                                        }}
                                    />
                                </div>
                                <div className="col-4 d-flex justify-content-between ">
                                    <label htmlFor="amountto" className="form-label  pt-2 start">Until This Date</label>
                                    <input
                                        type="date"
                                        className="form-Input w-100"
                                        id="date"
                                        name="date"
                                        disabled={DelegateActive === true ? false : true}
                                        value={formData?.date}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>
                                <div className='col-4 d-flex gap-2 pt-2 '>
                                    <input className="form-check-input"
                                        type="checkbox"
                                        id="Active" style={{ width: "20px", height: "20px" }}
                                        name="Active"
                                        checked={DelegateActive}
                                        onChange={(e) => handleDeleActiveSelection(e.target.checked)}
                                    />
                                    <label className='px-2'>Active</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setSupplierTab(!SupplierTab)}>
                    <div className='h6 pt-1'>Approval User List</div>
                </div>
                <div className={`slide-content ${SupplierTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 ${SupplierTab ? 'slide-in' : 'slide-out'}`}>
                        <ApprovalUserGrid rowData={rowData} fetchApprovalData={fetchApprovalData} />
                    </div>
                </div>
            </div>

            <Modal show={previewModal} size="lg" centered onHide={handleCloseSignaturePreview}>
                <Modal.Header closeButton>
                    <Modal.Title>Signature Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center" style={{ minHeight: '300px' }}>
                    {previewImage?.fileType === 'pdf' ? (
                        <iframe
                            src={previewImage.url}
                            title={previewImage.fileName}
                            style={{ width: '100%', height: '70vh', border: 'none' }}
                        />
                    ) : (
                        <img
                            src={previewImage?.url}
                            alt={previewImage?.fileName || 'Signature'}
                            style={{ maxWidth: '100%', maxHeight: '70vh', objectFit: 'contain' }}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ApprovalUser;
